import { render, staticRenderFns } from "./OrganizationPeriodReports.vue?vue&type=template&id=bb7530a0"
import script from "./OrganizationPeriodReports.vue?vue&type=script&lang=js"
export * from "./OrganizationPeriodReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports